<template>
  <div class="row col-md-12">
    <b-button variant="primary" size="sm" @click="addCrime" class="mb-2">Add Catatan Kriminal</b-button>
    <b-table striped hover :items="crimeData" :fields="crimeFields" show-empty>
      <template v-slot:cell(action)="row">
        <b-button @click="viewDetail(row.item)" variant="primary" size="sm"><feather-icon icon="EyeIcon" /></b-button>&nbsp;&nbsp;
        <b-button v-if="isValidUser" @click="removeData(row.item)" variant="danger" size="sm"><feather-icon icon="TrashIcon" /></b-button>
      </template>
      <template #empty>
        <loading v-if="LoadingCrime"></loading>
        <div v-if="!LoadingCrime" class="text-center my-3">
          Tidak ada data yang tersedia saat ini.
        </div>
      </template>
    </b-table>


    <b-modal v-model="crimeModal" title="Add Crime Record" hide-footer>
      <loading v-if="LoadingCrime"></loading>
      <validation-observer ref="usercrime" tag="form" @submit.prevent="submitCrime">
        <b-form v-if="!LoadingCrime" @submit.prevent="submitCrime">
          <b-form-group label="Pasal Pelanggaran">
            <validation-provider #default="{ errors }" name="pasal" rules="required">
              <multiselect v-model="selectedPasal" :options="pasalOption" :multiple="false" :close-on-select="true" :clear-on-select="true" placeholder="Pilih Pasal Pelanggaran" label="text" track-by="value"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label="Judul">
            <validation-provider #default="{ errors }" name="judul" rules="required">
              <b-form-input v-model="formCrime.judul" locale="en"></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label="Description">
            <validation-provider #default="{ errors }" name="Description" rules="required">
              <b-form-textarea id="description" v-model="formCrime.description" ></b-form-textarea>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-button type="submit" variant="primary">Simpan</b-button>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal v-model="detailCrimeModal" title="Crime Detail" hide-footer size="lg" centered>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Judul:">
            <div class="input-like-div" style="color:black">
              {{ crimeDetail.judul }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Pasal">
            <div class="input-like-div" style="color:black">
              {{ crimeDetail.pasal_name }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Pasal Type">
            <div class="input-like-div" style="color:black">
              {{crimeDetail.pasal_type}}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label="Description">
            <div class="input-like-div" style="color:black">
              {{ crimeDetail.description }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Inserted By">
            <div class="input-like-div" style="color:black">
              {{ crimeDetail.inserted_by_name }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Inserted Date">
            <div class="input-like-div" style="color:black">
              {{ crimeDetail.formated_inserted_date }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.full";
import axios from "axios";
import Loading from '@/templates/Loading.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import _interfaces from '@/templates/_interfaces';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Loading,
    ToastificationContent,
    Multiselect
  },
  data() {
    return {
      plate: null,
      LoadingCrime: false,
      crimeFields: [
        { key: "judul", label: "Judul" },
        { key: "pasal_name", label: "Pasal" },
        { key: "action", label: "Action" },
      ],
      pasalOption: [],
      crimeData: [],
      crimeDetail: [],
      crimeModal: false,
      selectedPasal: null,
      isValidUser: false,
      formCrime:_interfaces.catatankriminalKendaraan,
      detailCrimeModal: false,
    };
  },
  methods: {
    init: function() {
      let plate = this.$route.params.plate;
      this.getPasal();
      this.getData(plate);
      this.checkValidAccessButton(9);
    },
    getPasal: function(){
      axios.get("idp_dropdown/list").then((response) => {
        this.pasalOption = response.data.pasal
      });
    },
    addCrime: function(){
      this.crimeModal = true;
      this.resetForm();
    },
    viewDetail(row){
      this.crimeDetail = row;
      this.detailCrimeModal = true;
    },
    checkValidAccessButton(id_config){
      axios.post("idp/master/role-config/auth",{id:id_config}).then((response) => {
        this.isValidUser = response.data.valid
      })
    },
    getData(plate){
      this.LoadingCrime = true;
      axios.post("idp/vehicle/vehicledetail",{plate:plate}).then((response) => {
        this.crimeData = response.data.crime
      }).catch((error) => {
      }).finally(() => {
        this.LoadingCrime = false;
      });
    },
    submitCrime() {
      this.$refs.usercrime.validate().then((success) => {
        if(success){
          this.$swal.fire({
            title: 'Are you sure?????',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            background: '#262626',
            confirmButtonText: 'Yes, Submit it!',
            theme:'dark'
          }).then((result) => {
            // Jika pengguna menekan tombol "Yes", maka lakukan sesuatu
            if (result.isConfirmed) {
              this.LoadingCrime = true;
              setTimeout(() => {
                this.formCrime.id = this.$route.params.id
                this.formCrime.pasal = this.selectedPasal.value
                this.formCrime.plate = this.$route.params.plate;
                axios.post("idp/vehicle/addcrime",this.formCrime).then((response) => {
                  if(response.data.status == 2000){
                    this.$swal({
                      title: "Success",
                      icon: "success",
                      background: "black",
                      confirmButtonColor: "#7367f0",
                      confirmButtonText: "Close",
                    });
                  }
                }).catch((error) => {
                  if (error.status === 4000) {
                    localStorage.clear();
                    this.$router.push({ path: "/login" });
                    ({
                      title: "Login Expired",
                      message: "Sesi Login Habis",
                    });
                  }
                }).finally(() => {
                  this.Loading = false;
                  this.crimeModal = false;
                  this.getData(this.$route.params.plate)
                });
              }, 1000);
            }
          }) 
        }
      });
    },
    removeData: function(row){
      this.$swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        background: '#262626',
        confirmButtonText: 'Yes, delete it!',
        theme:'dark'
      }).then((result) => {
        // Jika pengguna menekan tombol "Yes", maka lakukan sesuatu
        if (result.isConfirmed) {
          this.LoadingCrime = true
          axios.post("idp/vehicle/delete-crime",{id:row.id}).then((response) => {
          }).finally(() => {
            this.LoadingCrime = false
            this.getData(this.$route.params.plate)
          });
        }
      })
    },
    resetForm() {
      for (const i in _interfaces.catatankriminalKendaraan) {
        _interfaces.catatankriminalKendaraan[i] = null
      }
      this.formCrime = _interfaces.catatankriminalKendaraan
      this.selectedPasal = null
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style scoped>
/* Gaya khusus untuk halaman detail kendaraan */
.vehicle-detail-page {
  padding: 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.vehicle-image {
  width: 100%;
  max-width: 400px;
  height: auto;
}

.vehicle-specifications {
  margin-top: 20px;
}
.input-like-div {
  border: 1px solid #babcc2; /* Atur ketebalan dan warna border sesuai kebutuhan */
  padding: .375rem .75rem; /* Atur ukuran padding sesuai kebutuhan */
  border-radius: .25rem; /* Atur radius sudut untuk membuat kotak lebih halus */
  background-color: #babcc2; /* Atur warna latar belakang sesuai kebutuhan */
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out; /* Animasi saat hover */
}

.input-like-div:hover {
  border-color: #6c757d; /* Atur warna border saat hover */
}

.is-dpo {
  background-color: #ea5455;
  border-radius: 5%;
  animation: blink-animation 1s infinite alternate; /* Animasi kedipan */
}

@keyframes blink-animation {
  0% {
    background-color: #ea5455;
  }
  10% {
    background-color: transparent; /* Ganti dengan warna latar belakang asli jika diperlukan */
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>